import Icon from "@mui/icons-material/LiveTv";

import RelayEventCreate from "./RelayEventCreate";
import RelayEventEdit from "./RelayEventEdit";
import RelayEventsList from "./RelayEventsList";

export default {
  list: RelayEventsList,
  create: RelayEventCreate,
  edit: RelayEventEdit,
  icon: Icon,
  label: "Relay Events",
  options: { label: "Relay Events" },
  name: "relay-events",
};
